export default __webpack_public_path__ + "static/media/DownArrowBlack.6f2e8eb9.svg";